import React from 'react';
import { uniqueId } from 'lodash';

import { Box, SxProps, Theme, Typography } from '@mui/material';

const StringItemList: React.FunctionComponent<{
  items: string | undefined;
  sx?: SxProps<Theme>;
}> = ({ items, sx }) => {
  const itemsArr = items?.split('-');
  itemsArr && itemsArr.shift();

  return (
    <Box sx={sx}>
      {itemsArr?.map((d) => (
        <Typography key={uniqueId()} variant='body2' fontWeight='Light'>
          -{d}
        </Typography>
      ))}
    </Box>
  );
};

export default StringItemList;
